import React from 'react';

const AgentDetailCard = ({ title, points }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h3 className="font-semibold text-xl mb-4 text-blue-800">{title}</h3>
      <ul className="list-disc list-inside space-y-2 text-gray-700">
        {points.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    </div>
  );
};

export default AgentDetailCard;